// Signed-out site footer: brand + socials, link columns, legal line.
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PRODUCTS, SOCIALS } from './siteLinks';
import { USE_CASE_PAGES } from '../useCases/useCaseData';
import { TOOLS } from '../tools/toolData';
import bumpups_logo from '../../assets/images/default/bumpups-logo-final.png';
import './siteFooter.css';

const COLUMNS = [
  { title: 'Product', links: PRODUCTS.map(p => ({ to: p.to, label: p.title })) },
  { title: 'Use cases', links: USE_CASE_PAGES.map(p => ({ to: `/use-cases/${p.slug}`, label: p.label })) },
  { title: 'Free tools', links: TOOLS.map(t => ({ to: `/tools/${t.slug}`, label: t.label })) },
  {
    title: 'Company',
    links: [
      { to: '/pricing', label: 'Pricing' },
      { to: '/enterprise', label: 'Enterprise' },
      { to: '/news', label: 'News' },
      { to: '/changelog', label: 'Changelog' },
      { href: 'mailto:contact@bumpups.com', label: 'Contact us' },
    ],
  },
];

const FooterLink = ({ to, href, label }) => (
  to ? <Link to={to} className="mkf-link">{label}</Link> : <a href={href} className="mkf-link">{label}</a>
);

export default function SiteFooter() {
  return (
    <footer className="mkf">
      <div className="mk-container">
        <div className="mkf-top">
          <div className="mkf-brand">
            <Link to="/" aria-label="Bumpups home">
              <img src={bumpups_logo} alt="Bumpups" className="mkf-logo" width="94" height="28" loading="lazy" />
            </Link>
            <p className="mkf-tagline">
              <span className="mk-accent">Your videos, understood.</span> Upload a recording or paste a YouTube link, and get chapters, notes and answers in minutes.
            </p>
            <div className="mk-socials">
              {SOCIALS.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`Bumpups on ${s.label}`} className="mk-social">
                  <FontAwesomeIcon icon={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {COLUMNS.map(col => (
            <nav key={col.title} className="mkf-col" aria-label={col.title}>
              <p className="mkf-col-title">{col.title}</p>
              {col.links.map(l => <FooterLink key={l.label} {...l} />)}
            </nav>
          ))}
        </div>

        <div className="mkf-bottom">
          <p className="mkf-legal">© {new Date().getFullYear()} Webcafe Commerce LLC DBA _cafe_. All rights reserved.</p>
          <div className="mkf-legal-links">
            <Link to="/terms-of-service" className="mkf-link">Terms of Service</Link>
            <Link to="/privacy-policy" className="mkf-link">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
